import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { calculateRemainingDays } from '../../helpers'
import {
  getAllocationInfo,
  getIsBudgetAllocationType
} from '../../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { formatNumber, calc } from '../../../../../../../../helpers/numbers'

import { rightSelector } from '../../../../../../../../modules/selectors/rights'
import { lineItemsSelector } from '../../../../../../../../modules/selectors/lineItems'
import { selectedPartnershipSelector } from '../../../../../../../../modules/selectors/partnerships'

import { GOOGLE_AD_MANAGER_AD_ACCOUNT } from '../../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useInventoryColumnsStyles from '../../styles'
import useStyles from './styles'

const InventorySectionHeader = ({
  inventory,
  showAllocation = false,
  showRemaining = false,
  allocation,
  remainingBudget
}) => {
  const inventoryListClasses = useInventoryColumnsStyles()
  const classes = useStyles()

  const right = useSelector(rightSelector)
  const existingLineItems = useSelector(lineItemsSelector)
  const { [GOOGLE_AD_MANAGER_AD_ACCOUNT]: gamAccount } = useSelector(selectedPartnershipSelector)
  const { isPercentageAllocation } = getAllocationInfo(right)
  const isBudgetAllocationType = getIsBudgetAllocationType(right)
  const currencySymbol = gamAccount?.currency_symbol || ''

  const remainingDays = useMemo(() => {
    return calculateRemainingDays({
      right,
      existingLineItems,
      inventory
    })
  }, [right, existingLineItems, inventory])

  const { totalRemainingDays, totalDays } = useMemo(() => {
    const totalRemainingDays = calc(remainingDays.videoRemainingDays).add(calc(remainingDays.displayRemainingDays))
    const totalDays = calc(remainingDays.totalDays).mul(2)
    return { totalRemainingDays, totalDays }
  }, [remainingDays])

  if (isPercentageAllocation) {
    return (
      <div className={classnames(inventoryListClasses.columnsWrapper, classes.inventorySectionHeader)}>
        <div className={inventoryListClasses.allocationColumn}>{showAllocation && `${allocation}%`}</div>
        <div className={inventoryListClasses.remainingColumn}>
          {showRemaining && `${totalRemainingDays}/${totalDays}`}
        </div>
      </div>
    )
  } else if (isBudgetAllocationType) {
    return (
      <div className={classnames(inventoryListClasses.columnsWrapper, classes.inventorySectionHeader)}>
        <div className={inventoryListClasses.allocationColumn}>
          {showAllocation && `${currencySymbol}${formatNumber(allocation, { max: 2 })}`}
        </div>
        <div className={inventoryListClasses.remainingColumn}>
          {showRemaining && `${currencySymbol}${formatNumber(remainingBudget, { max: 2 })}`}
        </div>
      </div>
    )
  } else {
    // quantity allocation
    return (
      <div className={classnames(inventoryListClasses.columnsWrapper, classes.inventorySectionHeader)}>
        <div className={inventoryListClasses.allocationColumn}>
          {showAllocation && `${formatNumber(allocation, { max: 2 })}`}
        </div>
        <div className={inventoryListClasses.remainingColumn}>
          {showRemaining && `${formatNumber(remainingBudget, { max: 2 })}`}
        </div>
      </div>
    )
  }
}

InventorySectionHeader.propTypes = {
  inventory: PropTypes.arrayOf(PropTypes.object).isRequired,
  showAllocation: PropTypes.bool,
  showRemaining: PropTypes.bool,
  allocation: PropTypes.number
}

export default InventorySectionHeader
